import Header from "../components/Header";
import Main from "../components/Main";
import Footer from "../components/Footer";

export default function HomePage() {
  return (
    <>
      <Header></Header>
      <Main></Main>
      <Footer></Footer>
    </>
  );
}
